import React from 'react';
import { TableRow, TableRowColumn, Checkbox, Avatar, FontIcon, MenuItem } from 'material-ui';
import { getStatusColor } from '../../contracting/contractingUtils';
import moment from 'moment';
import R from 'ramda';

class RequestRowDumb extends React.Component {
  constructor() {
    super();
    this.state = {
      expanded: false,
    }
  }

  render() {
    const {
      request,
    } = this.props;
    const { locationId, respondedContracts } = request;
    const tcRatesReceived = Boolean(respondedContracts && respondedContracts.length);
    const fileExists = Boolean(request.files && request.files.length);
    const externalRatesReceived = !locationId && (request.buyerChecked || fileExists);
    const ratesReceived = tcRatesReceived || externalRatesReceived;
    const shownState = (() => {
      if (request.inDLQ) return 'EZ Load in Progress';
      return ratesReceived ? 'rates sent' : 'request';
    })();
    const unread = Boolean(!request.isViewed && !locationId);
    return (
      <div
        className="flex-center"
        style={{ lineHeight: '48px', borderBottom: '1px solid #e0e0e0' }}
      >
        <div className="flex-center" style={{ overflow: 'visible', width: '65%' }}>
          {
            R.call(R.cond([
              [() => request.from && request.from.avatar, R.always(<Avatar src={request.from.avatar} style={{ marginTop: '4px' }}/>)],
              [R.T, R.always(<Avatar>{R.head(request.from.name)}</Avatar>)],
            ]))
          }
          <div style={{ fontWeight: unread ? 'bold' : '', marginLeft: '24px' }}>
            {request.from.name}
          </div>
        </div>
        <div style={{ padding: 0, textAlign: 'center', width: '15%', lineHeight: '16px' }}>
          <span style={{ color: getStatusColor(shownState) }}>{shownState}</span>
        </div>
        <div style={{ padding: 0, textAlign: 'center', fontSize: '10px', width: '10%' }}>
          {`${moment.utc(request.startDate).format('D MMM YY')} -\n${moment.utc(request.endDate).format('D MMM YY')}  `}
        </div>
        <div style={{ padding: 0, fontSize: '11px', textAlign: 'center', width: '8%' }}>
          {moment(request.updatedAt).calendar(null, {
            sameDay: 'h:mm a',
            lastDay: 'D MMM YY',
            lastWeek: 'D MMM YY',
            sameElse: 'D MMM YY',
          })}
        </div>
      </div>
    );
  }
}

export default RequestRowDumb;



// WEBPACK FOOTER //
// ./src/app/components/assets-landing/basic-request-list/request-row.jsx